import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SiretPendingAssignmentTopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.S8} ${Spacing.S24};
  background-color: ${Color.Yellow100};

  & button {
    background-color: ${Color.White};
  }
`
